let urlBackend;
let frontendUrl;

switch (process.env.REACT_APP_ENVIRONMENT) {
  case 'production':
    urlBackend = process.env.REACT_APP_PROD_BACKEND_URL;
    frontendUrl = process.env.REACT_APP_PROD_FRONTEND_URL;
    break;
  case 'development':
    urlBackend = process.env.REACT_APP_DEV_BACKEND_URL;
    frontendUrl = process.env.REACT_APP_DEV_FRONTEND_URL;
    break;
  case 'localhost':
    urlBackend = process.env.REACT_APP_LOCALHOST_BACKEND_URL; // o una clave específica para staging si es necesario
    frontendUrl = process.env.REACT_APP_LOCALHOST_FRONTEND_URL;
    break;
  default:
    // Configuración por defecto (puede ser desarrollo local, por ejemplo)
    urlBackend = process.env.REACT_APP_DEV_BACKEND_URL;
}
const config = {
  baseAPI: urlBackend,
  frontendUrl,
};

module.exports = config;
